module.exports = __webpack_public_path__ + "fonts/Avenir-Roman.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Avenir/Avenir-Roman.woff2
// module id = 3476
// module chunks = 0